import { gql } from "@apollo/client";

export const ADD_OFFICE = gql`
  mutation addOffice($officeInput: OfficeInput) {
    addOffice(officeInput: $officeInput) {
      _id
      name
    }
  }
`;

export const GET_ALL_COMPANY_OFFICES = gql`
  query (
    $companyId: String!
    $pagination: pagination
    $searchText: String
    $sort: sort
  ) {
    getAllCompanyOffice(
      companyId: $companyId
      pagination: $pagination
      searchText: $searchText
      sort: $sort
    ) {
      offices {
        _id
        name
        address
        city
        state
        zip
        state
        phone
        isDefault
        subscribedOffices
        listing_extension_period
      }
      totalCount
    }
  }
`;

export const UPDATE_OFFICE = gql`
  mutation updateOffice($officeInput: OfficeInput) {
    updateOffice(officeInput: $officeInput) {
      _id
      name
    }
  }
`;
